export default __webpack_public_path__ + "static/media/LinkedIn.0be8a0ea.svg";